// Product detail content for each Aufsteller variant (DE / EN).
// Texts are written specifically for in7sekunden – do not match competitor wording.

const T = (de, en) => ({ de, en });

export const PRODUCTS = {
  "google-white": {
    image: "stand-2",
    tag: T("Google-Bewertung", "Google review"),
    title: T("Google Aufsteller – White Edition", "Google Stand – White Edition"),
    headline: T(
      "Hell, ruhig, freundlich – Bewertungen direkt nach dem Termin.",
      "Bright, calm, friendly – reviews right after the appointment."
    ),
    intro: T(
      "Die White Edition ist für Räume gemacht, in denen viel Tageslicht fällt: Empfänge, Praxen, helle Studios und moderne Ladenlokale. Der Aufsteller wirkt zurückhaltend und macht trotzdem unmissverständlich klar, was als nächstes passieren soll – ein kurzer Tap, eine Bewertung.",
      "The White Edition is built for rooms with plenty of daylight: receptions, practices, bright studios and modern retail. The stand stays in the background and still makes the next step crystal clear – a short tap, a review."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Beim Anlegen des Smartphones öffnet sich die Google-Bewertungsseite Ihres Unternehmens direkt – ohne Zwischenschritt, ohne Suche. Das Sterne-Layout der Karte signalisiert sofort den Anlass und reduziert die typische Hemmschwelle, eine Bewertung zu hinterlassen.",
          "When the phone is placed against the stand, your Google review page opens directly – without an intermediate step, without searching. The star layout of the card immediately signals the purpose and lowers the usual barrier to leaving a review."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Am Empfangstresen einer Praxis, neben der Kasse einer Apotheke, am Check-in eines Hotels oder am Bedienplatz eines Friseurs. Überall dort, wo der Termin gerade endet und der Kunde noch eine kurze, ungestörte Sekunde hat.",
          "On the reception desk of a practice, next to the till of a pharmacy, at the check-in of a hotel or at the work station of a barber. Anywhere the appointment has just ended and the customer has one calm second left."
        ),
      },
      {
        title: T("Material & Verarbeitung", "Material & finish"),
        body: T(
          "Acryl-basiert, mit matter Front, sauberer Kantenführung und stabilem Standfuß. Der NFC-Chip sitzt im Inneren der Karte – nicht sichtbar, aber zuverlässig erreichbar. Reinigung mit weichem Tuch, ohne Aufwand.",
          "Acrylic-based, with a matte front, clean edges and a stable foot. The NFC chip sits inside the card – not visible but reliably reachable. Cleaning with a soft cloth, without effort."
        ),
      },
    ],
  },

  "google-black": {
    image: "stand-1",
    tag: T("Google-Bewertung", "Google review"),
    title: T("Google Aufsteller – Black Edition", "Google Stand – Black Edition"),
    headline: T(
      "Dunkel, ruhig, präsent – ohne aufdringlich zu wirken.",
      "Dark, calm, present – without ever feeling pushy."
    ),
    intro: T(
      "Die Black Edition setzt einen klaren visuellen Akzent, ohne ein Raumkonzept zu stören. Sie passt zu Studios mit warmem Licht, zu Hotels und Lounges sowie zu Standorten, an denen ein zurückhaltend-elegantes Auftreten zur Marke gehört.",
      "The Black Edition sets a clear visual accent without disturbing a room concept. It fits studios with warm light, hotels and lounges, as well as locations where a restrained, elegant appearance is part of the brand."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Ein Tap, und Ihre Google-Bewertungsseite ist offen. Die dunkle Front lenkt den Blick auf das, was wichtig ist: das Logo, die Sterne und die klare Aufforderung. Das ergibt eine kurze, freundliche Geste, die selbstverständlich wirkt.",
          "One tap, and your Google review page is open. The dark front draws the eye to what matters: the logo, the stars and the clear call to action. The result is a short, friendly gesture that feels natural."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Auf dunklen Holztheken, vor warmen Wandlichtern und in Räumen, in denen weiße Schilder zu hell wirken würden – etwa Boutique-Hotels, Barbershops, Wellness-Studios oder Premium-Gastronomie.",
          "On dark wooden counters, in front of warm wall lights and in rooms where white signs would feel too bright – for example boutique hotels, barbershops, wellness studios or premium gastronomy."
        ),
      },
      {
        title: T("Material & Verarbeitung", "Material & finish"),
        body: T(
          "Acryl mit tiefem Schwarzton, leicht satinierter Oberfläche und integriertem NFC-Modul. Die Standfläche ist auf typische Tresenhöhen abgestimmt und bleibt auch bei seitlichem Anschauen sicher stehen.",
          "Acrylic in deep black, with a slightly satin surface and integrated NFC module. The stand foot is matched to typical counter heights and remains stable even when viewed from the side."
        ),
      },
    ],
  },

  "instagram-gradient": {
    image: "stand-3",
    tag: T("Instagram-Follow", "Instagram follow"),
    title: T("Instagram Aufsteller – Gradient Edition", "Instagram Stand – Gradient Edition"),
    headline: T(
      "Aufmerksamkeitsstark – aber nicht laut.",
      "Attention-grabbing – without being loud."
    ),
    intro: T(
      "Die Gradient Edition holt die Bildsprache von Instagram an den Tisch, ohne ein Café oder Studio in Werbung zu verwandeln. Der Verlauf signalisiert sofort die Plattform, der Aufsteller selbst bleibt eine ruhige Karte mit klarer Geste.",
      "The Gradient Edition brings the Instagram visual language to the table without turning a café or studio into an advert. The gradient signals the platform instantly, the stand itself stays a calm card with a clear gesture."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Ein Tap öffnet Ihr Instagram-Profil direkt im Browser – fertig zum Folgen. Kein Suchen nach dem Handle, keine Tippfehler, keine Reibung. Das ist der Unterschied zwischen «würde gerne» und «habe gerade».",
          "A tap opens your Instagram profile straight in the browser – ready to follow. No searching for the handle, no typos, no friction. That's the difference between 'would like to' and 'just did'."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Auf Cafétischen, an Salonspiegeln, am Empfang von Kosmetikstudios oder im Showroom – also überall, wo Bilder, Atmosphäre und Erlebnis ohnehin Teil der Marke sind.",
          "On café tables, beside salon mirrors, at the reception of beauty studios or in the showroom – wherever images, atmosphere and experience are already part of the brand."
        ),
      },
      {
        title: T("Material & Verarbeitung", "Material & finish"),
        body: T(
          "Acryl mit gedrucktem Verlauf in Pink, Lila und Orange. Der Druck ist UV-stabil und bleibt auch nach Monaten frisch. Die Karte ist robust gegenüber leichten Spritzern und Reinigungsmitteln.",
          "Acrylic with a printed gradient in pink, purple and orange. The print is UV-stable and stays fresh after months. The card is robust against light splashes and cleaning agents."
        ),
      },
    ],
  },

  "facebook-blue": {
    image: "stand-4",
    tag: T("Facebook-Follower", "Facebook follower"),
    title: T("Facebook Aufsteller – Blue Edition", "Facebook Stand – Blue Edition"),
    headline: T(
      "Klar, freundlich, vertraut – für Standorte mit aktiver Community.",
      "Clear, friendly, familiar – for locations with an active community."
    ),
    intro: T(
      "Facebook ist nicht überholt – im Gegenteil: Für Vereine, lokale Geschäfte, Veranstaltungen und Gemeinden ist es bis heute eine der zentralen Plattformen. Die Blue Edition holt sie sichtbar an den Kontaktpunkt.",
      "Facebook isn't outdated – quite the opposite: for clubs, local shops, events and communities it is still a central platform. The Blue Edition brings it visibly to the point of contact."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Tap auf den Aufsteller, und Ihre Facebook-Seite öffnet sich direkt – «Gefällt mir» und «Folgen» sind nur einen weiteren Tap entfernt. Wer regelmäßig postet, sieht seine Reichweite ohne Werbebudget wachsen.",
          "Tap the stand and your Facebook page opens immediately – Like and Follow are just one more tap away. If you post regularly, you'll see your reach grow without ad budget."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Im Vereinsheim, im Familienbetrieb, in der Bäckerei, im Bürgerbüro, im Tierladen, beim Fachhandel – überall, wo Stammkundschaft und lokale Bindung zählen.",
          "In the club house, in family-run businesses, in the bakery, in the local office, in the pet shop, in specialty retail – wherever loyal customers and local ties matter."
        ),
      },
      {
        title: T("Material & Verarbeitung", "Material & finish"),
        body: T(
          "Acryl mit klarem Facebook-Blauton und dem vertrauten Logo. Die Karte ist kratzfest und für längere Standzeiten an Theken, Schaufenstern und Empfängen ausgelegt.",
          "Acrylic in a clear Facebook blue with the familiar logo. The card is scratch-resistant and built for extended use on counters, shop windows and reception desks."
        ),
      },
    ],
  },

  "tiktok-neon": {
    image: "stand-5",
    tag: T("TikTok-Follow", "TikTok follow"),
    title: T("TikTok Aufsteller – Black Edition", "TikTok Stand – Black Edition"),
    headline: T(
      "Klar, dunkel, hochwertig – passend zu Studios, Bars und modernen Lounges.",
      "Clear, dark, premium – made for studios, bars and modern lounges."
    ),
    intro: T(
      "Die Black Edition setzt auf eine ruhige, dunkle Optik mit dem TikTok-Logo als Mittelpunkt. Sie fügt sich in Räume mit gedämpftem Licht ein und unterstützt eine Marke, die Reels, Kurzvideos und Erlebnis-Content in den Vordergrund stellt.",
      "The Black Edition relies on a calm, dark look with the TikTok logo at its centre. It blends into rooms with subdued lighting and supports brands that put reels, short videos and experience content first."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Ein Tap öffnet Ihr TikTok-Profil – fertig zum Folgen, mit allen Videos sofort sichtbar. Gerade in einem Bar-Setting passiert das oft im selben Moment wie das Aufnehmen eigener Inhalte.",
          "A tap opens your TikTok profile – ready to follow, with all videos immediately visible. In a bar setting that often happens in the very moment guests are recording their own content."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Cocktailbars, Speakeasies, Late-Night-Restaurants, Eventlocations und Concept-Stores – überall, wo Marke und Atmosphäre sich gegenseitig verstärken.",
          "Cocktail bars, speakeasies, late-night restaurants, event venues and concept stores – wherever brand and atmosphere reinforce each other."
        ),
      },
      {
        title: T("Material & Verarbeitung", "Material & finish"),
        body: T(
          "Schwarze Acryl-Front mit präzisem Druck des TikTok-Logos. Die Optik bleibt zurückhaltend, fällt aber durch den klaren Kontrast sofort ins Auge.",
          "Black acrylic front with a precise print of the TikTok logo. The look stays understated yet catches the eye immediately through the clear contrast."
        ),
      },
    ],
  },

  "paypal-pay": {
    image: "stand-6",
    tag: T("Zahlung", "Payment"),
    title: T("PayPal Aufsteller – Pay Edition", "PayPal Stand – Pay Edition"),
    headline: T(
      "Bezahlen, wenn der Kartenleser gerade nicht passt.",
      "Pay when the card reader simply isn't an option."
    ),
    intro: T(
      "Nicht jeder Standort hat ein klassisches Terminal – und nicht jede Situation eignet sich für Bargeld. Der PayPal-Aufsteller ist für genau diese Lücken gemacht: Trinkgeld, Kleinbeträge, Privat-Sessions, mobile Dienstleistungen oder Pop-up-Standorte.",
      "Not every location has a classic terminal – and not every situation is right for cash. The PayPal stand is made for exactly these gaps: tips, small amounts, private sessions, mobile services or pop-up locations."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Tap auf den Aufsteller öffnet Ihre PayPal.me-Seite. Der Kunde gibt den Betrag ein, bestätigt – fertig. Ohne App-Installation, ohne Bargeldsuche, ohne Kartenlesegerät.",
          "A tap opens your PayPal.me page. The customer enters the amount, confirms – done. Without app installation, without searching for cash, without a card reader."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Friseure, Kosmetiker:innen, Fußpflege, Trainer, kleine Praxen, Markthändler, mobile Dienstleister, Vereins-Stände – überall, wo Beträge schnell und vertrauensvoll fließen sollen.",
          "Hairdressers, beauticians, foot care, trainers, small practices, market traders, mobile service providers, club stands – wherever amounts should move quickly and with trust."
        ),
      },
      {
        title: T("Hinweise", "Notes"),
        body: T(
          "Voraussetzung ist ein PayPal-Konto und ein eingerichteter PayPal.me-Link. Wir konfigurieren den Aufsteller mit Ihrer URL, sodass keine Eingabe vor Ort nötig ist.",
          "Requires a PayPal account and an active PayPal.me link. We configure the stand with your URL so no input on site is needed."
        ),
      },
    ],
  },

  "whatsapp-chat": {
    image: "stand-7",
    tag: T("WhatsApp-Chat", "WhatsApp chat"),
    title: T("WhatsApp Aufsteller – Chat Edition", "WhatsApp Stand – Chat Edition"),
    headline: T(
      "Direkter Draht zum Kunden – ohne Visitenkarte, ohne Telefonansage.",
      "A direct line to the customer – without business cards, without phone menus."
    ),
    intro: T(
      "Viele Anfragen scheitern daran, dass Kunden den Anruf nicht auslösen. Die Chat Edition löst das: Ein Tap öffnet einen vorbereiteten WhatsApp-Chat mit Ihrem Unternehmen – inklusive optionaler Standardnachricht.",
      "Many enquiries fail because the customer never makes the call. The Chat Edition solves that: a tap opens a prepared WhatsApp chat with your business – including an optional default message."
    ),
    sections: [
      {
        title: T("Was der Kunde erlebt", "What the customer experiences"),
        body: T(
          "Antippen, kurz tippen, abschicken. Auf der anderen Seite landet die Nachricht direkt in Ihrem WhatsApp-Postfach – mit oder ohne Vorlage, je nach Konfiguration.",
          "Tap, type briefly, send. On your side the message lands directly in your WhatsApp inbox – with or without a default template, depending on your configuration."
        ),
      },
      {
        title: T("Wo er besonders gut funktioniert", "Where it works particularly well"),
        body: T(
          "Praxen, Studios, Werkstätten, Immobilienschauen, Messestände, Hotels und überall, wo Anfragen außerhalb der Geschäftszeit eingehen oder ein Anruf zu hochschwellig wäre.",
          "Practices, studios, workshops, property viewings, trade fair booths, hotels and anywhere enquiries arrive outside opening hours or a phone call would feel too formal."
        ),
      },
      {
        title: T("Hinweise", "Notes"),
        body: T(
          "Wir richten die Nummer und – falls gewünscht – eine vorbefüllte Nachricht für Sie ein. Bitte beachten Sie die WhatsApp-Business-Bedingungen für die geschäftliche Nutzung.",
          "We set up the number and, on request, a pre-filled message for you. Please observe the WhatsApp Business terms for commercial use."
        ),
      },
    ],
  },

  "custom": {
    image: "custom",
    tag: T("Wunsch-Plattform", "Custom platform"),
    title: T("Custom Aufsteller – Ihr Link", "Custom Stand – Your link"),
    headline: T(
      "Trustpilot, Webseite, Termin, Newsletter oder mehrere Links auf einer Karte.",
      "Trustpilot, website, booking, newsletter or several links on a single card."
    ),
    intro: T(
      "Manchmal ist der wichtigste Link weder eine Bewertung noch ein Social-Profil. Für genau diese Fälle gibt es den Custom Aufsteller: Sie wählen das Ziel, wir setzen das Layout, den NFC-Link und den QR-Code passend dazu auf.",
      "Sometimes the most important link is neither a review nor a social profile. The Custom Stand is made for exactly these cases: you choose the destination, we build the layout, NFC link and QR code to match."
    ),
    sections: [
      {
        title: T("Mögliche Ziele", "Possible destinations"),
        body: T(
          "Trustpilot, ProvenExpert, jameda, Tripadvisor, Buchungs-Tools (Calendly, Setmore, Treatwell), Webseite, Newsletter-Anmeldung, Online-Shop, Speisekarten-PDF, mehrsprachige Landingpage – oder eine Kombination als Auswahl-Seite.",
          "Trustpilot, ProvenExpert, doctor portals, Tripadvisor, booking tools (Calendly, Setmore, Treatwell), websites, newsletter sign-ups, online shops, menu PDFs, multilingual landing pages – or a combination via a choice page."
        ),
      },
      {
        title: T("Was wir liefern", "What we deliver"),
        body: T(
          "Layout-Entwurf, Druckdatei, NFC-Programmierung und QR-Code. Auf Wunsch auch ein eigenes kleines Auswahl-Menü, falls mehrere Links parallel relevant sind.",
          "Layout draft, print file, NFC programming and QR code. On request also a small choice menu if several links are relevant in parallel."
        ),
      },
      {
        title: T("Preis", "Price"),
        body: T(
          "Für Custom-Aufsteller erstellen wir ein individuelles Angebot, abhängig von Aufwand und Stückzahl. Bitte nutzen Sie das Kontaktformular und beschreiben Sie kurz Ihren Wunsch.",
          "For custom stands we create an individual offer based on effort and quantity. Please use the contact form and briefly describe your wish."
        ),
      },
    ],
  },
};
